export const paginatorConfiguration = {
  defaultPageIndex: 0,
  pageSizeOptions: [30, 60, 90],
  pageLargeSizeOptions: [50, 100, 150],
  searchPageSizeOptions: [12, 24, 48],
  sortimentPageSizeOptions: [100, 125, 150],
};
